var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyButton',{class:_vm.styling,attrs:{"buttonText":_vm.buttonText,"disabled":_vm.disabled,"id":'extend-offers-accept'},on:{"click":_vm.goNext}})
}
var staticRenderFns = []

export { render, staticRenderFns }